import React from 'react';
import { useHistory } from 'react-router-dom';
import { TertiaryButton, TertiaryButtonProps } from '@workday/canvas-kit-react/button';

export interface TertiaryButtonLinkProps extends TertiaryButtonProps {
    className?: string;
    children: React.ReactNode;
    to: string;
    replace?: boolean;
    context?: string;
}

export function TertiaryButtonLink({ to, children, replace, className, context, ...rest }: TertiaryButtonLinkProps) {
    const history = useHistory();

    function onClick() {
        const location = {
            pathname: to,
            state: {
                context: context
            }
        };
        if (replace) {
            history.replace(location);
        } else {
            history.push(location);
        }
    }

    return (
        <TertiaryButton onClick={onClick} size='large' {...rest} className={className}>
            {children}
        </TertiaryButton>
    );
}
